export class DCCommunityPortalSR {
    "SR Number": string = "";
    "SR Type": string = "";
    "Sub Type": string = "";
    "CSN": string = "";
}

export class ListOfDCCommunityPortalSRIO {
    "DC Community Portal SR": DCCommunityPortalSR = new DCCommunityPortalSR();
}

export class DCIncomingHierarchy {
    MessageId: string = "";
    IntObjectName: string = "DC Community Portal SR IO";
    MessageType: string = "Integration Object";
    IntObjectFormat: string = "Siebel Hierarchical";
    "ListOfDC Community Portal SR IO": ListOfDCCommunityPortalSRIO =
        new ListOfDCCommunityPortalSRIO();
}

export class SecurityDepositBody {
    ProcessName: string = "DC Community Portal SR Process Wrapper WF";
    DCMethod: string = "GET_ATA_DEPOSIT_DETAILS";
    DCLanguage: string = "ENU";
    DCLoginName: string = "";
    DCIncomingHierarchy: DCIncomingHierarchy = new DCIncomingHierarchy();
}

export class SecurityDepositRequest {
    body: SecurityDepositBody = new SecurityDepositBody();
}
